interface FloatingIcon {
  emoji: string;
  top: string;
  left?: string;
  right?: string;
  delay: string;
}

interface FloatingIconsProps {
  desktopIcons: FloatingIcon[];
  mobileIcons?: FloatingIcon[];
}

export const FloatingIcons = ({ desktopIcons, mobileIcons }: FloatingIconsProps) => {
  const mobileIconsToRender = mobileIcons || desktopIcons.slice(0, 4);

  return (
    <>
      {/* Mobile Icons - smaller, fewer */}
      {mobileIconsToRender.map((icon, index) => (
        <div
          key={`mobile-${index}`}
          className="floating-icon floating-icon-mobile md:hidden"
          style={{
            top: icon.top,
            left: icon.left,
            right: icon.right,
            animationDelay: icon.delay,
          }}
        >
          {icon.emoji}
        </div>
      ))}
      
      {/* Desktop Icons - larger, more numerous */}
      {desktopIcons.map((icon, index) => (
        <div
          key={`desktop-${index}`}
          className="floating-icon hidden md:block"
          style={{
            top: icon.top,
            left: icon.left,
            right: icon.right,
            animationDelay: icon.delay,
          }}
        >
          {icon.emoji}
        </div>
      ))}
    </>
  );
};
